import {
  SiPhp, SiLaravel, SiCodeigniter, SiNodedotjs, SiExpress,
  SiReact, SiVuedotjs, SiAngular, SiJavascript, SiJquery, SiHtml5, SiCss3, SiBootstrap,
  SiIonic, SiCapacitor,
  SiMysql, SiDocker, SiLinux, SiAmazonwebservices,
  SiJest,
  SiGit, SiGithub, SiGitlab, SiJira,
  SiClaude, SiAnthropic,
} from 'react-icons/si';
import { TbApi, TbTestPipe, TbArrowsShuffle, TbDatabase, TbBolt } from 'react-icons/tb';

export const BIRTH_DATE = { year: 2000, month: 3, day: 23 }; // 23 de marzo de 2000
export const CAREER_START = new Date(2020, 3, 1); // abril 2020, primer puesto en Thalamus
export const CV_PATH = '/assets/CV_Tomas_Bastiani.pdf';

// La edad se incrementa automáticamente cada 23 de marzo
export function getAge(today = new Date()) {
  const { year, month, day } = BIRTH_DATE;
  let age = today.getFullYear() - year;
  const m = today.getMonth() + 1;
  if (m < month || (m === month && today.getDate() < day)) age -= 1;
  return age;
}

export function getYearsOfExperience(today = new Date()) {
  const months = (today.getFullYear() - CAREER_START.getFullYear()) * 12 + (today.getMonth() - CAREER_START.getMonth());
  return Math.floor(months / 12);
}

export const contact = {
  email: 'tomas.bastiani@hotmail.com',
  phone: '+54 11 6191 6707',
  whatsapp: 'https://api.whatsapp.com/send?phone=541161916707',
  linkedin: 'https://www.linkedin.com/in/tom%C3%A1s-bastiani-034a29170/',
  github: 'https://github.com/tomasbastiani',
};

export const skillCategories = [
  {
    key: 'cat_backend',
    skills: [
      { name: 'PHP', icon: SiPhp },
      { name: 'Laravel', icon: SiLaravel },
      { name: 'CodeIgniter', icon: SiCodeigniter },
      { name: 'Node.js', icon: SiNodedotjs },
      { name: 'Express.js', icon: SiExpress },
      { name: 'REST APIs', icon: TbApi },
    ],
  },
  {
    key: 'cat_frontend',
    skills: [
      { name: 'React', icon: SiReact },
      { name: 'Vue.js', icon: SiVuedotjs },
      { name: 'Angular', icon: SiAngular },
      { name: 'JavaScript', icon: SiJavascript },
      { name: 'jQuery', icon: SiJquery },
      { name: 'AJAX', icon: TbArrowsShuffle },
      { name: 'HTML', icon: SiHtml5 },
      { name: 'CSS', icon: SiCss3 },
      { name: 'Bootstrap', icon: SiBootstrap },
    ],
  },
  {
    key: 'cat_mobile',
    skills: [
      { name: 'Ionic', icon: SiIonic },
      { name: 'Capacitor', icon: SiCapacitor },
    ],
  },
  {
    key: 'cat_data',
    skills: [
      { name: 'MySQL', icon: SiMysql },
      { name: 'SQL', icon: TbDatabase },
      { name: 'Docker', icon: SiDocker },
      { name: 'Linux', icon: SiLinux },
      { name: 'AWS', icon: SiAmazonwebservices },
    ],
  },
  {
    key: 'cat_testing',
    skills: [
      { name: 'Jest', icon: SiJest },
      { name: 'PHPUnit', icon: TbTestPipe },
    ],
  },
  {
    key: 'cat_tools',
    skills: [
      { name: 'Git', icon: SiGit },
      { name: 'GitHub', icon: SiGithub },
      { name: 'GitLab', icon: SiGitlab },
      { name: 'Jira', icon: SiJira },
      { name: 'ScrumBan', icon: TbBolt },
    ],
  },
  {
    key: 'cat_ai',
    skills: [
      { name: 'Claude', icon: SiClaude },
      { name: 'Claude Code', icon: SiAnthropic },
    ],
  },
];

export const languages = [
  { key: 'lang_en', level: 'level_advanced', cefr: 'B2', value: 75 },
  { key: 'lang_pt', level: 'level_basic', cefr: 'A1', value: 18 },
];

// Fechas en formato 'AAAA-MM'; end: null significa "Actualidad"
export const experiences = [
  {
    role: 'role_sr_fullstack',
    company: 'Thalamus SA',
    location: 'CABA, Argentina',
    start: '2021-05',
    end: null,
    bullets: 'bullets_sr_fullstack',
    tech: ['PHP', 'Laravel', 'CodeIgniter', 'Node.js', 'Express', 'Vue.js', 'Angular', 'React', 'MySQL', 'Docker', 'PHPUnit', 'Jest', 'Git', 'Claude Code', 'Jira', 'ScrumBan'],
  },
  {
    role: 'role_mobile',
    company: 'Freelance',
    location: 'remote',
    start: '2024-08',
    end: '2025-05',
    bullets: 'bullets_mobile',
    tech: ['Ionic', 'Capacitor', 'Angular', 'React', 'Node.js', 'Express', 'REST APIs', 'Git'],
  },
  {
    role: 'role_web',
    company: 'Freelance',
    location: 'remote',
    start: '2020-08',
    end: '2021-05',
    bullets: 'bullets_web',
    tech: ['PHP', 'Laravel', 'CodeIgniter', 'Node.js', 'Vue.js', 'Angular', 'React', 'jQuery', 'MySQL', 'Git'],
  },
  {
    role: 'role_dba',
    company: 'Thalamus SA',
    location: 'CABA, Argentina',
    start: '2020-04',
    end: '2021-04',
    bullets: 'bullets_dba',
    tech: ['SQL', 'HTML', 'CSS', 'AWS'],
  },
];

export const clientLogos = [
  'bat.png',
  'clorotec.png',
  'corteva1.jpg',
  'haras.jpg',
  'mccain1.png',
  'neto.png',
  'raizen.png',
  'redpoint.jpg',
  'logo_renault.jpg',
  'shell.png',
];

export const education = [
  { title: 'edu_esba', institution: 'ESBA', type: 'type_degree', period: '2026' },
  { title: 'edu_utn_fullstack', institution: 'inst_utn', type: 'type_course', period: '2022 – 2023' },
  { title: 'edu_uba', institution: 'inst_uba', type: 'type_degree', period: '2020 – 2022' },
  { title: 'edu_udemy_react', institution: 'Udemy', type: 'type_course', period: '2021' },
  { title: 'edu_eit_php', institution: 'Educación IT', type: 'type_course', period: '2021' },
  { title: 'edu_utn_adv', institution: 'inst_utn', type: 'type_course', period: '2020' },
  { title: 'edu_utn_intro', institution: 'inst_utn', type: 'type_course', period: '2019' },
  { title: 'edu_uces', institution: 'inst_uces', type: 'type_degree', period: '2018 – 2019' },
];

export function formatMonth(value, lang) {
  const [y, m] = value.split('-').map(Number);
  const label = new Intl.DateTimeFormat(lang === 'es' ? 'es-AR' : 'en-US', { month: 'short', year: 'numeric' })
    .format(new Date(y, m - 1, 1));
  return label.charAt(0).toUpperCase() + label.slice(1).replace('.', '');
}
